import heroFactory from './hero-factory_1770394445_000.png';
import heroProducts from './hero-products_1770394445_000.png';
import heroProcess from './hero-process_1770394444_000.png';
import aboutInterior from './about-interior_1770394444_000.png';
import catCapacitors from './cat-capacitors_1770394461_000.png';
import catRegulators from './cat-regulators_1770394460_000.png';
import catOilCapacitors from './cat-oil-capacitors_1770394462_000.png';
import catComponents from './cat-components_1770394460_000.png';
import appMotors from './app-motors_1770394485_000.png';
import appFans from './app-fans_1770394486_000.png';
import appLighting from './app-lighting_1770394484_000.png';
import appAgriculture from './app-agriculture_1770394483_000.png';
import teamEngineer from './team-engineer_1770394502_000.png';
import teamTechnician from './team-technician_1770394504_000.png';
import teamManager from './team-manager_1770394504_000.png';
import enquiryBg from './enquiry-bg_1770394504_000.png';

export const images = {
  hero: [heroFactory, heroProducts, heroProcess],
  about: aboutInterior,
  categories: {
    capacitors: catCapacitors,
    regulators: catRegulators,
    oilCapacitors: catOilCapacitors,
    components: catComponents,
  },
  applications: {
    motors: appMotors,
    fans: appFans,
    lighting: appLighting,
    agriculture: appAgriculture,
  },
  team: {
    engineer: teamEngineer,
    technician: teamTechnician,
    manager: teamManager,
  },
  enquiry: enquiryBg,
};
